module.exports = __webpack_public_path__ + "img/checkbox_checked.3035b79f.svg";